<template>
  <div class="drawer" :class="{'active': active}">
    <DrawerBurger class="toggle" :class="{'active': active}" @click.native="active = !active"/>
    <div class="cover" @click="active = false"/>
    <div class="inner">
      <div class="list">
        <DrawerItem>
          <router-link :to="{name:'home'}">首页</router-link>
        </DrawerItem>
        <span v-if="isAuthenticated">
          <DrawerItem v-for="task in allTasks" :key="task.id">
            <router-link :to="{name:'task',params:{id:task.id}}">{{task.name}}</router-link>
          </DrawerItem>
        </span>
        <DrawerItem v-if="isAuthenticated" @click.native="quit()">注销</DrawerItem>
        <DrawerItem v-else>
          <router-link :to="{name:'login'}">登陆</router-link>
        </DrawerItem>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { DrawerItem, DrawerBurger } from '@/components'

export default {
  name: 'drawer',
  components: {
    DrawerItem,
    DrawerBurger
  },
  data () {
    return {
      active: false
    }
  },
  computed: {
    ...mapGetters([
      'isAuthenticated',
      'allTasks'
    ]),
    isActive () {
      return this.active
    }
  },
  methods: {
    ...mapActions([
      'logout'
    ]),
    close () {
      this.active = false
    },
    quit () {
      this.logout()
    }
  },
  watch: {
    active (value) {
      document.body.style.overflow = value ? 'hidden' : 'auto'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/stylesheets/layer.scss';
@import '~@/stylesheets/color.scss';

.drawer {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  overflow:hidden;
  pointer-events: none;
  div {
    pointer-events: auto;
  }
  .toggle {
    position: fixed;
    top: 1rem;
    left: 1.5rem;
    z-index: $layer-top;
  }
  .cover {
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.5);
    opacity: 0;
    z-index: $layer-backstage;
    transition: all .3s cubic-bezier(0.075, 0.82, 0.165, 1);
  }
  .inner {
    position: absolute;
    top: 0;
    right: auto;
    bottom: 0;
    left: 0;
    height: 100%;
    width: 10rem;
    background: $color_bleu_de_france;
    transform: translateX(-100%) rotateZ(0deg);
    transition: transform .3s cubic-bezier(0.075, 0.82, 0.165, 1);

    display:flex;
    justify-content: flex-start;
    align-items: center;

    box-shadow: 0rem 0rem 0rem rgba(0,0,0,.25);
  }
  &.active {
    z-index: $layer-top;
    .cover {
      pointer-events: auto;
      opacity: 1;
      z-index: $layer-backstage;
    }
    .inner {
      z-index: $layer-cover;
      transform: translateX(0%) rotateZ(1deg) scale(1.2);
      box-shadow: .25rem 0rem 1rem rgba(0,0,0,.25);
    }
  }
}
</style>
